import { Component, OnInit } from '@angular/core';
import { IFolder, UsersService, IUser, IDashboard } from '../../users.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute, Router } from '@angular/router';
import { RolesService } from 'src/app/pages/roles/roles.service';
import { DialogComponent } from './dialog/dialog.component';
import {combineLatest, Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-folders-list',
  templateUrl: './folders-list.component.html',
  styleUrls: ['./folders-list.component.scss']
})
export class FoldersListComponent implements OnInit {
  userId: string;
  folders: IFolder[] = [];
  displayedColumns: string[] = ['select', 'name', 'screensCount', 'totalUsers', 'ellipsis'];
  selection = new SelectionModel<IFolder>(true, []);
  selectedFolder: IFolder;
  selectedIndex: number;
  loading = false;
  visibleUsersModal: boolean = false;
  userName: string = null;
  url: string;

  sharedFolder: IFolder = null;
  allFoldersNotBelongToUser: boolean = false;
  firstOwnFolderIndex: number;


  constructor(private service: UsersService, private route: ActivatedRoute, private rolesService: RolesService,
    private snackBar: MatSnackBar, public dialog: MatDialog, private router: Router) { }

  ngOnInit() {
    this.loading = true;
    this.userId = this.service.selectedUserId;
    this.getUserName();
    this.getFolders();
    this.loading = false;
    this.url = environment.apiUrl;
  }

  getUserName() {
    this.service.getUsers().subscribe(res => {
      let user = res.find(x => x.id === this.userId);
      this.userName = user.email;
    })
  }

  getFolders() {
    this.service.getUserFolders(this.userId).subscribe(res => {
      this.folders = res;
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.folders.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.folders.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row + 1}`;
  }

  openDialog(rename: boolean): void {
    if (rename) {
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '400px',
        data: { name: this.selectedFolder.name, rename: true }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          this.service.setFolder(result, this.userId, this.selectedFolder.id).subscribe(res => {
            this.getFolders();
          });
        }
      });
      this.selection.clear();


    } else {
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '400px',
        data: { name: '', rename: false }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          this.service.setFolder(result, this.userId).subscribe(res => {
            this.getFolders();
          });
        }
      });
      this.selection.clear();

    }
  }

  deleteFolders(selected?: boolean) {
    const isConfirm = confirm('Вы действительно хотите удалить выбранную папку?');
    if (isConfirm) {
      const ids = [];
      if (selected) {
        ids.push(this.selectedFolder.id);
      } else {
        for (let i = 0; i < this.selection.selected.length; i++) {
          ids.push(this.selection.selected[i].id);
        }
      }
      this.service.deleteFolders(ids).subscribe(res => {
        this.getFolders();
        this.selection.clear();
      });
    }
  }

  openReports() {
    this.service.setSelectedFolderId(this.selectedFolder.id);
    this.router.navigate(['/main/users/list', this.userId, 'dashboards', this.selectedFolder.id]);
  }

  toggleUsersModal(event) {
    this.visibleUsersModal = event;
  }

  share(users) {
    let arr = [];
    if (this.selection.selected.length > 0) {
      for (let i = 0; i < this.selection.selected.length; i++) {
        arr.push(this.service.getUserReports(this.selection.selected[i].id, this.userId));
      }
    } else {
      arr.push(this.service.getUserReports(this.selectedFolder.id, this.userId));
    }

    if (arr.length > 0) {
      combineLatest([arr]).subscribe(v => {
        let dashboardIds: number[] = [];
        v.map(it => dashboardIds.push(...it.map(d => d.id)));
        if (dashboardIds.length > 0) {
          this.service.shareDashboards(users.map(u => u.userId), dashboardIds).subscribe(
            () => {
              this.selection.clear();
              // this.getAllFolders();
              this.snackBar.open('Вы успешно поделились выбранными папками', '', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'right',
                panelClass: ['snackbar-succes']
              });
            },
            () => {
              this.snackBar.open('Не получилось поделиться папками', '', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'right',
                panelClass: ['snackbar-error']
              });
            }
          );
        } else {
          if (this.selection.selected.length === 1) {
            this.snackBar.open('В выбранной папке нет экранов!', '', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'right',
              panelClass: ['snackbar-error']
            });
          } else {
            this.snackBar.open('В выбранных папках нет экранов!', '', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'right',
              panelClass: ['snackbar-error']
            });
          }
        }
      });
    }
    this.toggleUsersModal(false);
  }

  getAllFolders() {
    combineLatest([this.service.getFolders()]).subscribe(data => {
      this.folders = [];
      this.folders = data[0];
      // Выставление всех прав доступа для папок
      this.folders.map((folder) => {
        if (folder.permissions && folder.permissions.length > 0) {
          folder.viewGrant = folder.permissions.some(elem => elem === 'View');
          folder.shareGrant = folder.permissions.some(elem => elem === 'Share');
          folder.deleteGrant = folder.permissions.some(elem => elem === 'Delete');
          folder.renameGrant = folder.permissions.some(elem => elem === 'Rename');
          folder.createReportGrant = folder.permissions.some(elem => elem === 'CreateReport');
          folder.deleteReportGrant = folder.permissions.some(elem => elem === 'DeleteReport');
        } else {
          folder.viewGrant = true;
          folder.shareGrant = true;
          folder.deleteGrant = true;
          folder.renameGrant = true;
          folder.createReportGrant = true;
          folder.deleteReportGrant = true;
        }
      });

      // убираем папку из массива, если пользователь не может ее просматривать
      this.folders = this.folders.filter(elem => elem.viewGrant);

      this.folders.map((elem, index) => {
        elem.hovered = false;
        elem.visibleMenu = false;
        elem.selected = false;


        if (elem.isSharedFolder) {
          this.sharedFolder = elem;
        }
      });
      // указывает на то, являются ли все папки собственными папками пользователя
      this.allFoldersNotBelongToUser = this.folders.every(x => x.ownerUserId.toString() !== this.userId);

      // Определение индекса начала папок пользователя
      for (let currentIndex = 0; currentIndex < this.folders.length; currentIndex++) {
        if (this.folders[currentIndex].ownerUserId.toString() === this.userId) {
          this.firstOwnFolderIndex = currentIndex;
          break;
        }
      }
      this.selection.clear();
    });
  }

}
